import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="wrap" style={{ padding: "60px 0" }}>
      <div className="hero__skeleton" style={{ height: 120 }} />
    </div>
  );
}

/** Requires any logged-in account. */
export function RequireAuth() {
  const { ready, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!ready) return <Loading />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}

/** Requires the admin account specifically. */
export function RequireAdmin() {
  const { ready, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (!ready) return <Loading />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
